import { authenticatedSession } from "@shuttlerock/auth";
import { ConfigService } from "@shuttlerock/configuration";
import {
  getTrackingConsent,
  productAnalytics,
  subscribeTrackingConsent,
} from "@shuttlerock/observability";
import type { createBrowserRouter } from "react-router";
import { analyticsRoute } from "./analytics-route";

/** Subscribe once at the router boundary, including routes rendered by error boundaries. */
export function connectAnalytics(router: ReturnType<typeof createBrowserRouter>) {
  productAnalytics.configure({
    token: ConfigService.MIXPANEL_TOKEN(),
    region: ConfigService.MIXPANEL_REGION(),
  });

  const update = () => {
    if (!router.state.initialized) return;
    const principalKey = authenticatedSession.getSnapshot()?.principalKey;
    productAnalytics.update({
      ...analyticsRoute(router.state),
      trackingAllowed: getTrackingConsent(principalKey).allowed,
      principalKey,
      unauthenticated: authenticatedSession.isUnauthenticated(),
      environment: ConfigService.ENVIRONMENT(),
    });
  };

  const unsubscribeRouter = router.subscribe(update);
  const unsubscribeSession = authenticatedSession.subscribe(update);
  const unsubscribeConsent = subscribeTrackingConsent(update);
  update();
  return () => {
    unsubscribeRouter();
    unsubscribeSession();
    unsubscribeConsent();
  };
}
